import React, { useCallback, useContext } from 'react';
import { CurrentPlanContext } from '../hooks/CurrenPlanContext';
import { useUpgradeModal } from '../hooks/useUpgradeModal';
import { isPaidPlan } from '../utils/plans';

interface Props {
    title?: string;
    value: boolean;
    onChange: (value: boolean) => void;
}

export default function AdvancedSettingsToggle({ title = 'Advanced Settings', value, onChange }: Props) {
    const currentPlan = useContext(CurrentPlanContext);
    const [UpgradeModal, showUpgradePopup] = useUpgradeModal();
    const handleClick = useCallback(
        () => (!currentPlan || isPaidPlan(currentPlan) ? onChange(!value) : showUpgradePopup()),
        [currentPlan, onChange, showUpgradePopup, value]
    );
    return (
        <>
            <button onClick={handleClick} className="underline mb-8">
                {value ? 'Hide' : 'Show'} {title}
            </button>
            <UpgradeModal />
        </>
    );
}
